module.exports = __webpack_public_path__ + "assets/img/6515f91890821343d9a958540677bfc0.png";